import React from 'react'
import { Input } from 'antd'
import PropTypes from 'prop-types'

const { Search } = Input

/**
 * InventorySearchBar component for searching inventory items
 * @param {string} searchTerm - Current search term value
 * @param {function} handleSearch - Function to handle search input changes
 * @returns {React.ReactElement} Search input component
 */
const InventorySearchBar = ({ searchTerm, handleSearch }) => {
  /**
   * Handle search input change
   * @param {string} value - New search value
   */
  const onSearchChange = (value) => {
    try {
      handleSearch(value)
    } catch (error) {
      console.error('Error occurred during search:', error)
    }
  }

  const containerStyle = {
    width: '100%',
    maxWidth: '450px',
    marginBottom: '20px',
    position: 'relative'
  }

  const searchStyle = {
    boxShadow: '0 3px 8px rgba(0, 0, 0, 0.15)',
    borderRadius: '8px',
    overflow: 'hidden'
  }

  const buttonStyle = {
    backgroundColor: '#1890ff',
    borderColor: '#1890ff'
  }

  return (
    <div style={containerStyle}>
      <Search
        placeholder='Search inventory items...'
        allowClear
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        aria-label='Search inventory items'
        data-testid='inventory-search-input'
        size='large'
        style={searchStyle}
        enterButton
      />
    </div>
  )
}

InventorySearchBar.propTypes = {
  searchTerm: PropTypes.string,
  handleSearch: PropTypes.func.isRequired
}

InventorySearchBar.defaultProps = {
  searchTerm: ''
}

export default React.memo(InventorySearchBar)
